module.exports = "/dist/montserrat-latin-100.svg?2e95991f47cb11fa0f90155cde7145cd";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-100.svg
// module id = 66
// module chunks = 0